var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 12.1667H15.5V10.5H7.16667V12.1667ZM0.5 8L3.83333 11.3333V4.66667L0.5 8ZM0.5 15.5H15.5V13.8333H0.5V15.5ZM0.5 0.5V2.16667H15.5V0.5H0.5ZM7.16667 5.5H15.5V3.83333H7.16667V5.5ZM7.16667 8.83333H15.5V7.16667H7.16667V8.83333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTick);
export default __webpack_public_path__ + "static/media/leftTick.7da875fa80240ae8ad8d0e456ab5d158.svg";
export { ForwardRef as ReactComponent };